import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiSearch, FiCalendar, FiUser, FiHome, FiAlertCircle, FiClock, FiTrash2, FiEdit, FiPrinter } from 'react-icons/fi';
import PersonSelectionModal from './PersonSelectionModal';
import { database } from '../../Firebase';
import { ref, onValue, push, remove, update } from 'firebase/database';

const AtikramanNotice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const { grampanchayatName, arthikVarshLabel } = location.state || {}; // Keep context if needed

  const [view, setView] = useState('list'); // 'list' or 'form'
  const [searchTerm, setSearchTerm] = useState('');
  const [showPersonModal, setShowPersonModal] = useState(false);
  
  const [formData, setFormData] = useState({
    id: '',
    noticeNo: '',
    noticeDate: new Date().toISOString().split('T')[0], // Default to today
    personName: '',
    personFirstName: '',
    personMiddleName: '',
    personLastName: '',
    personAadhar: '',
    personMobile: '',
    personAddress: '',
    placeInfo: '',
    crimeInfo: '',
    actionDays: ''
  });

  // Data from Firebase
  const [notices, setNotices] = useState([]);

  // Fetch Data from Firebase
  useEffect(() => {
    const noticesRef = ref(database, 'Grampanchayat/Gramniddhi/Certificates and licenses/AtikramanNotice list');
    
    const unsubscribe = onValue(noticesRef, (snapshot) => {
      const fetchedData = [];
      snapshot.forEach((childSnapshot) => {
        fetchedData.push({
          id: childSnapshot.key,
          ...childSnapshot.val()
        });
      });
      setNotices(fetchedData);
    });

    return () => unsubscribe();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handlePersonSelect = (person) => {
    setFormData(prev => ({
      ...prev,
      personName: person.fullName,
      personFirstName: person.firstName || '',
      personMiddleName: person.middleName || '',
      personLastName: person.lastName || '',
      personAadhar: person.aadharNo || '',
      personMobile: person.mobileNo || '',
      personAddress: person.address || ''
    }));
    setShowPersonModal(false);
  };

  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      noticeNo: item.noticeNo || '',
      noticeDate: item.noticeDate || '',
      personName: item.personName || '',
      personFirstName: item.personFirstName || '',
      personMiddleName: item.personMiddleName || '',
      personLastName: item.personLastName || '',
      personAadhar: item.personAadhar || '',
      personMobile: item.personMobile || '',
      personAddress: item.personAddress || '',
      placeInfo: item.placeInfo || '',
      crimeInfo: item.crimeInfo || '',
      actionDays: item.actionDays || ''
    });
    setView('form');
  };

  const handleDelete = (id) => {
    if (window.confirm('तुम्ही नक्की हे रेकॉर्ड हटवू इच्छिता?')) {
      const recordRef = ref(database, `Grampanchayat/Gramniddhi/Certificates and licenses/AtikramanNotice list/${id}`);
      remove(recordRef)
        .then(() => {
           // Success handled by onValue
        })
        .catch((error) => {
          alert('हटवताना त्रुटी आली: ' + error.message);
        });
    }
  };

  const handlePrint = (notice) => {
      const printWindow = window.open('', '_blank');
      // Basic Print Template
      printWindow.document.write(`
        <html>
          <head>
            <title>Atikraman Notice - ${notice.noticeNo}</title>
            <style>
              body { font-family: 'Times New Roman', serif; padding: 40px; }
              .header { text-align: center; margin-bottom: 20px; }
              .title { font-size: 24px; font-weight: bold; margin-bottom: 5px; }
              .subtitle { font-size: 18px; font-weight: bold; }
              .divider { border-top: 2px solid black; margin: 20px 0; }
              .notice-header { text-align: center; font-weight: bold; text-decoration: underline; font-size: 20px; margin: 20px 0; }
              .content { font-size: 16px; line-height: 1.6; margin-bottom: 20px; }
              .details { margin: 20px 0; }
              .row { display: flex; justify-content: space-between; margin-bottom: 10px; }
              .sign-area { margin-top: 80px; display: flex; justify-content: space-between; }
              .sign-box { text-align: center; width: 200px; }
            </style>
          </head>
          <body>
            <div class="header">
               <div class="title">ग्रामपंचायत कार्यालय ${grampanchayatName || ''}</div>
               <div class="subtitle">ता. [तालुका], जि. [जिल्हा]</div>
            </div>
            
            <div class="divider"></div>

            <div class="row">
               <div><strong>जावक क्र.:</strong> ${notice.noticeNo}</div>
               <div><strong>दिनांक:</strong> ${new Date(notice.noticeDate).toLocaleDateString('en-GB')}</div>
            </div>

            <div class="notice-header">अतिक्रमण नोटीस</div>

            <div class="content">
              <strong>प्रति,</strong><br/>
              श्री./श्रीमती <strong>${notice.personName}</strong><br/>
              रा. [गाव/शहर]
            </div>

            <div class="content">
              <strong>विषय:</strong> ग्रामपंचायत हद्दीतील अतिक्रमण तात्काळ काढून घेणेबाबत.
            </div>

            <div class="content">
               महोदय/महोदया,<br/><br/>
               वरिल विषयास अनुसरुन आपणास कळविण्यात येते की, आपण ग्रामपंचायत हद्दीतील 
               <strong>${notice.placeInfo}</strong> या जागेवर 
               <strong>${notice.crimeInfo}</strong> अशा स्वरुपाचे बेकायदेशीर अतिक्रमण केले असल्याचे निदर्शनास आले आहे.
               <br/><br/>
               तरी सदरचे अतिक्रमण ही नोटीस मिळाल्यापासून <strong>${notice.actionDays}</strong> दिवसांच्या आत आपण स्वखर्चाने काढून घ्यावे. 
               अन्यथा, ग्रामपंचायतीमार्फत अतिक्रमण काढण्यात येईल व त्याचा येणारा सर्व खर्च आपल्याकडून वसूल केला जाईल 
               तसेच आपल्यावर कायदेशीर कारवाई करण्यात येईल, याची नोंद घ्यावी.
            </div>

            <div class="sign-area">
                <div class="sign-box">
                    <br/><br/>
                    <strong>ग्रामसेवक</strong><br/>
                    ग्रामपंचायत ${grampanchayatName || ''}
                </div>
                <div class="sign-box">
                    <br/><br/>
                    <strong>सरपंच</strong><br/>
                    ग्रामपंचायत ${grampanchayatName || ''}
                </div>
            </div>
            
            <script>
                window.onload = function() { window.print(); }
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
  };

  const handleSave = () => {
    if (!formData.noticeNo || !formData.personName) {
        alert('कृपया नोटीस क्र. आणि व्यक्तीचे नाव भरा');
        return;
    }

    const recordData = {
        noticeNo: formData.noticeNo,
        noticeDate: formData.noticeDate,
        personName: formData.personName,
        personFirstName: formData.personFirstName,
        personMiddleName: formData.personMiddleName,
        personLastName: formData.personLastName,
        personAadhar: formData.personAadhar,
        personMobile: formData.personMobile,
        personAddress: formData.personAddress,
        placeInfo: formData.placeInfo,
        crimeInfo: formData.crimeInfo,
        actionDays: formData.actionDays,
        updatedAt: new Date().toISOString()
    };

    if (formData.id) {
        // Update existing
        const recordRef = ref(database, `Grampanchayat/Gramniddhi/Certificates and licenses/AtikramanNotice list/${formData.id}`);
        update(recordRef, recordData)
            .then(() => {
                alert('माहिती यशस्वीरित्या अपडेट केली!');
                resetForm();
            })
            .catch((error) => {
                alert('अपडेट करताना त्रुटी आली: ' + error.message);
            });
    } else {
        // Add new
        const listRef = ref(database, 'Grampanchayat/Gramniddhi/Certificates and licenses/AtikramanNotice list');
        push(listRef, recordData)
            .then(() => {
                alert('माहिती यशस्वीरित्या जतन केली!');
                resetForm();
            })
            .catch((error) => {
                alert('जतन करताना त्रुटी आली: ' + error.message);
            });
    }
  };

  const resetForm = () => {
    setView('list');
    setFormData({
        id: '',
        noticeNo: '',
        noticeDate: new Date().toISOString().split('T')[0],
        personName: '',
        personFirstName: '',
        personMiddleName: '',
        personLastName: '',
        personAadhar: '',
        personMobile: '',
        personAddress: '',
        placeInfo: '',
        crimeInfo: '',
        actionDays: ''
    });
  };

  const handleCancel = () => {
    resetForm();
  };

  // Filter notices based on search
  const filteredNotices = notices.filter(item => 
    item.personName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    item.noticeNo?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8 font-poppins">
      
      {/* Header / Title Section */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-white rounded-lg shadow-sm p-4 border-l-4 border-[#267c77] flex justify-between items-center">
            <div>
                 <h1 className="text-xl font-bold text-gray-800">
                    {view === 'list' ? 'अतिक्रमण नोटीस यादी' : 'अतिक्रमण नोटीस माहिती'}
                 </h1>
            </div>
            <div className="flex gap-2">
                 <button 
                   onClick={() => navigate('/asthapan/certificates', { state: location.state })}
                   className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition"
                 >
                   मागे जा
                 </button>
                 {view === 'list' && (
                   <button 
                     onClick={() => {
                        setFormData({
                            id: '',
                            noticeNo: '',
                            noticeDate: new Date().toISOString().split('T')[0],
                            personName: '',
                            personFirstName: '',
                            personMiddleName: '',
                            personLastName: '',
                            personAadhar: '',
                            personMobile: '',
                            personAddress: '',
                            placeInfo: '',
                            crimeInfo: '',
                            actionDays: ''
                        });
                        setView('form');
                     }}
                     className="px-4 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition"
                   >
                     नवीन
                   </button>
                 )}
            </div>
        </div>
      </div>

      {view === 'list' ? (
        /* LIST VIEW */
        <div className="max-w-7xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
          
          {/* Search Bar */}
          <div className="p-4 border-b border-gray-200 flex gap-4">
             <div className="relative flex-1">
                <FiSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input 
                  type="text" 
                  placeholder="अर्जदाराचे नाव किंवा नोटीस क्र. शोधा..." 
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#267c77]"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
             </div>
             <button className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition">
                शोधणे
             </button>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-[#267c77] text-white">
                  <th className="p-3 border font-medium">नोटीस क्र.</th>
                  <th className="p-3 border font-medium">नोटीस दिनांक</th>
                  <th className="p-3 border font-medium">अर्जदाराचे नाव</th>
                  <th className="p-3 border font-medium text-center">क्रिया</th>
                </tr>
              </thead>
              <tbody>
                {filteredNotices.length === 0 ? (
                    <tr>
                        <td colSpan="4" className="p-4 text-center text-gray-500">
                            माहिती उपलब्ध नाही.
                        </td>
                    </tr>
                ) : (
                    filteredNotices.map((notice, idx) => (
                        <tr key={notice.id || idx} className="hover:bg-gray-50 border-b">
                            <td className="p-3 border font-medium">{notice.noticeNo}</td>
                            <td className="p-3 border">{notice.noticeDate}</td>
                            <td className="p-3 border font-medium text-gray-800">{notice.personName}</td>
                            <td className="p-3 border text-center flex justify-center gap-2">
                                <button
                                    onClick={() => handlePrint(notice)}
                                    className="text-[#267c77] hover:text-[#1e6b66] p-1 hover:bg-[#267c77]/10 rounded"
                                    title="Print"
                                >
                                    <FiPrinter />
                                </button>
                                <button 
                                    onClick={() => handleEdit(notice)}
                                    className="text-[#267c77] hover:text-[#1e6b66] p-1 hover:bg-[#267c77]/10 rounded"
                                    title="Edit"
                                >
                                    <FiEdit />
                                </button>
                                <button 
                                    onClick={() => handleDelete(notice.id)}
                                    className="text-red-600 hover:text-red-800 p-1 hover:bg-red-100 rounded"
                                    title="Delete"
                                >
                                    <FiTrash2 />
                                </button>
                            </td>
                        </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>

           {/* Pagination (Static placeholders) */}
           <div className="p-2 border-t bg-[#267c77] text-white flex justify-center items-center gap-2">
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">|&lt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&lt;&lt;</button>
                <span className="px-3 py-1 bg-white/20 rounded text-sm">1</span>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;&gt;</button>
                <button className="px-2 py-1 bg-white/20 rounded hover:bg-white/30 text-sm">&gt;|</button>
           </div>
        </div>
      ) : (
        /* FORM VIEW */
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6">
            <div className="space-y-6">
                
                {/* Notice No */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">अतिक्रमण नोटीस क्र.:</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text" 
                            name="noticeNo"
                            value={formData.noticeNo}
                            onChange={handleInputChange}
                            placeholder="अतिक्रमण नोटीस क्र."
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-50"
                         />
                    </div>
                </div>

                {/* Date */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">नोटीस दिनांक:</label>
                    <div className="md:col-span-3 relative">
                         <input 
                            type="date"
                            name="noticeDate"
                            value={formData.noticeDate}
                            onChange={handleInputChange} 
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

                 {/* Person Name */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">व्यक्तीचे नाव :</label>
                    <div className="md:col-span-3 flex gap-2">
                         <input 
                            type="text"
                            name="personName"
                            value={formData.personName}
                            // onChange={handleInputChange} // Remove handler or keep readOnly
                            readOnly
                            placeholder="व्यक्तीचे नाव (निवडण्यासाठी ... बटणावर क्लिक करा)"
                            className="flex-1 p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5 bg-gray-200 cursor-not-allowed"
                         />
                         <button 
                            onClick={() => setShowPersonModal(true)}
                            className="px-3 bg-[#267c77] text-white rounded hover:bg-[#1e6b66]"
                        >
                            ...
                         </button>
                    </div>
                </div>

                 {/* Place Info */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
                    <label className="text-gray-700 font-medium md:col-span-1 pt-2">जागेची माहिती:</label>
                    <div className="md:col-span-3">
                         <textarea 
                            name="placeInfo"
                            value={formData.placeInfo}
                            onChange={handleInputChange}
                            placeholder="जागेची माहिती"
                            rows="2"
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5 resize-none"
                         />
                    </div>
                </div>

                {/* Crime Info */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-start">
                    <label className="text-gray-700 font-medium md:col-span-1 pt-2">गुन्हाची माहिती:</label>
                    <div className="md:col-span-3">
                         <textarea 
                            name="crimeInfo"
                            value={formData.crimeInfo}
                            onChange={handleInputChange}
                            placeholder="गुन्हाची माहिती"
                            rows="2"
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5 resize-none"
                         />
                    </div>
                </div>

                   {/* Action Days */}
                 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-center">
                    <label className="text-gray-700 font-medium md:col-span-1">कारवाई दिवस:</label>
                    <div className="md:col-span-3">
                         <input 
                            type="text"
                            name="actionDays"
                            value={formData.actionDays}
                            onChange={handleInputChange} 
                            placeholder="कारवाई दिवस"
                            className="w-full p-2 border border-gray-300 rounded focus:ring-2 focus:ring-[#267c77] py-1.5"
                         />
                    </div>
                </div>

            </div>

             {/* Footer Buttons */}
             <div className="mt-8 flex justify-center gap-4 py-4 bg-[#267c77]/10 rounded-b-lg">
                <button 
                  onClick={handleSave}
                  className="px-6 py-2 bg-[#267c77] text-white rounded hover:bg-[#1e6b66] transition font-medium"
                >
                    साठविणे
                </button>
                <button 
                  onClick={handleCancel}
                  className="px-6 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition font-medium"
                >
                    रद्द करणे
                </button>
             </div>
        </div>
      )}

      {/* Person Selection Modal */}
      <PersonSelectionModal 
        isOpen={showPersonModal}
        onClose={() => setShowPersonModal(false)}
        onSelect={handlePersonSelect}
      />
    </div>
  );
};

export default AtikramanNotice;
